export const DEBUG = true;

//based on vuexy version 5.4
export const VERSION = "0.0.1";

// Backend API endpointss
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
// Serviroutes Backend API endpoints
export const SERVIROUTES_API_BASE_URL = process.env.VUE_APP_SERVIROUTES_API_BASE_URL;

export const REFRESH_TOKEN_URL = "/auth";

/**
 * Key for local storage.
 *
 * Set the key to use in local storage to hold persistant data. If logged in,
 * you can see this key by going to Chrome > dev tools > application tab,
 * then choosing "Local Storage" and "http://localhost:8080".
 *
 * @type {string}
 */

export const STORAGE_KEY = "awesome-vue";

// Add your API key here
export const libraries = ["awesome-lib", "drawing"];
